import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import {Router } from '@angular/router';
import {GS1LoadingService, GS1NotificationService } from '@gs1france/gs1-components-library';
import {addressValidator, GLN, GLNInterface, GLNType } from 'src/app/models/gln.model';
import {RoleTypesList } from 'src/config/role-types.config';
import {countryList } from '../../../../config/country-lists';
import {GLNService } from '../../services/gln/gln.service';
import {Language, LanguagesService } from '../../services/languages/languages.service';
import {environment } from '../../../../environments/environment';
import parsePhoneNumber, { PhoneNumber } from 'libphonenumber-js';
import { StorageService } from '../../services/storage/storage.service';
import { GoogleMap, MapGeocoder } from '@angular/google-maps';
import {firstValueFrom} from 'rxjs';
import { OAuthService } from "angular-oauth2-oidc";
import { C1UserInfo } from "src/app/models/c1UserInfo.model";
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {OrganisationCodesList} from "../../../../config/orgnisation-code.config";
import {GoogleMapService} from "../../services/map/googlemap.service";

@Component({
  selector: 'single-page',
  templateUrl: './single-page.component.html',
  styleUrls: ['./single-page.component.scss'],
})

export class SinglePageComponent implements OnInit, OnDestroy,  AfterViewInit {
  countryName?: string;
  copied = false;
  GLNForm?: FormGroup;
  formatedPhone?: PhoneNumber;
  roleTypesList = RoleTypesList;
  organisationCodes = OrganisationCodesList;
  c1User?: C1UserInfo;
  idCompany?: string;
  dialogRef: MatDialogRef<any>;
  glnLatitude: number = 0;
  glnLongitude: number = 0;
  isGlnMapVisible = true;
  initRoleType = false;
  isGoogleReady = false;
  oldRoleType: string;
//Initial Map options..
 mapOptions: google.maps.MapOptions = {
   mapTypeId: 'roadmap',
   zoomControl: true,
   scrollwheel: false,
   disableDoubleClickZoom: false,
    minZoom:4,
    maxZoom:20,
    zoom:16,
    mapTypeControl:false,
    fullscreenControl:false,
    panControl: false,
    streetViewControl: false,
    draggable:false,
  }
 marker = {
    position: { lat: -200, lng:-200 },
 }

  @ViewChild('dialog') dialogContent: TemplateRef<any>;


  urlECLI = environment.URL_ECLI + 'entreprise/compte-entreprise';
  subs: any[] = [];
  languages!: Language[];
  countryList = countryList.sort((a, b) => {
    if (a['wording-fr'] === 'France') {
      return -1;
    } else if (b['wording-fr'] === 'France') {
      return 1;
    } else {
      return a['wording-fr'].localeCompare(b['wording-fr']);
    }
  });

  admin = false;
  isAddressChange = false;
  isAutoSet = false;
  streetNumber?: string;
  isorganization: boolean = false;
  islocation: boolean = false;
  roleTypesListFilter = RoleTypesList.filter(
    (item) => item.id !== 'ISLocation' && item.id !== 'ISORGANIZATION'
  );

  isNewAddress: boolean = false;

  /**
   * A boolean that determines whether or not the page is being loaded from the search.
   * @type {boolean}
   */
  @Input() fromSearch = false;

  /**
   * @param {GLN} gln - The GLN to display.
   */
  @Input() gln?: GLN;

  /**
   * A boolean that determines whether or not the edit mode is active the filter.
   * @param {boolean} [edit=false] - the boolean that determines whether or not the edit mode is active.
   * @returns None
   */
  @Input() edit: boolean = false;

  /**
   * Emits an event when the user ends editing button.
   * @param None
   * @returns the edited gln
   */
  @Output() stopEdit = new EventEmitter<GLN>();

  @Output() startEdit = new EventEmitter<void>();

  constructor(
    private router: Router,
    private loading: GS1LoadingService,
    private notifications: GS1NotificationService,
    private fb: FormBuilder,
    private glnService: GLNService,
    private _storage: StorageService,
    private _languages: LanguagesService,
    private _geoCoder: MapGeocoder,
    private oAuthService: OAuthService,
    private dialog: MatDialog,
    private googleMapService: GoogleMapService,
    private cdr: ChangeDetectorRef
  ) { };

  ngOnInit() {
    this.oAuthService.loadUserProfile().then((value: any) => {
      this.c1User = value.info as C1UserInfo;
      if (this.c1User && this.c1User.company_id) {
        this.idCompany = this.c1User.company_id;
      }
    });

    if (!this.gln) {
      throw new Error('UN GLN est obligatoire pour la single page');
    }

    this.languages = this._languages.getLanguagesList();

    this.setAdmin();

    /**
     * If the GLN has an address and a country code, then set the country name to the country's name in French.
     */
    if (this.gln && this.gln.address && this.gln.address.countryCode) {
      this.countryName = countryList.filter((country) =>this.gln && country['Code alpha-2'] === this.gln.address?.countryCode)[0]['wording-fr'];
    }

    this.formatPhone();

    if (this.edit) {
      this.initiateForm();
    }
  }

  ngOnDestroy(): void {
    for (let sub of this.subs) {
      sub.unsubscribe();
    }
  }

  private _map!: GoogleMap;

  @ViewChild('glnMap', { static: false })
  set map(value: GoogleMap) {
    this._map = value;
    if (value) {
      // Fires exactly when <google-map> enters DOM, google is guaranteed ready
      this.checkIfGeolocalisationIsSet(this.gln?.address);
    }
  }

  ngAfterViewInit() {
    this.googleMapService.load().then(() => {
      this.isGoogleReady = true;
      this.cdr.detectChanges();
    }).catch(err => console.error('Map failed:', err));
  }

  formatPhone() {
    if (this.gln?.contact?.phone) {
      this.formatedPhone = parsePhoneNumber(this.gln.contact.phone);
    }
  }

  initiateGlnMap() {
    this.glnLatitude = this.gln!.latitude ? Number(this.gln!.latitude.replace(',', '.')) : -200;
    this.glnLongitude = this.gln!.longitude ? Number(this.gln!.longitude.replace(',', '.')) : -200;
    if (this.glnLatitude == -200 || this.glnLongitude == -200) {
      this.isGlnMapVisible = false;
    } else {
      this.isGlnMapVisible = true;
    }

    if (this.isGlnMapVisible) {

      this.marker = {
        position: {lat: this.glnLatitude, lng: this.glnLongitude},
      }

      this.mapOptions = {
        ...this.mapOptions,
        center: {
          lat: this.marker.position.lat,
          lng: this.marker.position.lng
        }
      }
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(this.marker.position)
      this._map.fitBounds(bounds);
    }
  }

  /**
   * Gets the label for the given GLN type.
   * @param {GLNType} type - the GLN type to get the label for.
   * @returns The label for the given GLN type.
   */
  getLabelForType(type: GLNType) {
    return GLN.getLabelForType(type);
  }

  /**
   * Retrive the admin property of the user.
   * @returns None
   */
  async setAdmin() {
    this.admin = await this._storage.isAdmin();
  }
  /**
   * Initiates the form for the GLN.
   * @returns None
   */
  initiateForm() {
    this.GLNForm = this.fb.group({
      glnType: new FormGroup(
        {
          isLegalEntity: new FormControl(this.gln?.glnType?.isLegalEntity, null),
          isFixedPhysicalLocation: new FormControl(this.gln?.glnType?.isFixedPhysicalLocation, null),
          isMobilePhysicalLocation: new FormControl(this.gln?.glnType?.isMobilePhysicalLocation, null),
          isDigitalLocation: new FormControl(this.gln?.glnType?.isDigitalLocation, null),
          isFunction: new FormControl(this.gln?.glnType?.isFunction, null),
        },
        this.atLeastOne()
      ),
      language: [this.gln?.language || 'fr', Validators.required],
      roleType: [this.gln?.roleType || null, null],
      name: [this.gln?.name || null, Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(100),]),],
      parentOrganisationGLN: [this.gln?.parentOrganisationGLN || null, Validators.compose([Validators.pattern(/\d{13}/),Validators.max(9999999999999),Validators.maxLength(13)]),],
      digitalAddress: [this.gln?.digitalAddress || null,Validators.compose([Validators.maxLength(80)]),],
      address: new FormGroup(
        {
          postalName: new FormControl(this.gln?.address?.postalName || null, null ),
          addressLocality: new FormControl(this.gln?.address?.addressLocality || null, Validators.compose([Validators.maxLength(50), Validators.required])),
          postalCode: new FormControl(this.gln?.address?.postalCode || null, Validators.compose([Validators.maxLength(9), Validators.required])),
          streetAddress: new FormControl(this.gln?.address?.streetAddress || null, Validators.compose([Validators.maxLength(80), Validators.required])),
          streetAddress2: new FormControl(this.gln?.address?.streetAddress2 || null, Validators.maxLength(80)),
          countryCode: new FormControl(this.gln?.address?.countryCode || null, Validators.required ),
        },
        Validators.compose([addressValidator, Validators.required])
      ),
      url: [this.gln?.url || null, null],
      contact: new FormGroup({
        lastName: new FormControl(this.gln?.contact?.lastName || null, Validators.maxLength(50)),
        firstName: new FormControl(this.gln?.contact?.firstName || null,Validators.maxLength(50)),
        email: new FormControl(this.gln?.contact?.email || null,Validators.email),
        phone: new FormControl(this.gln?.contact?.phone || null, Validators.pattern(/\d{9,10}/)),
      }),
      isPublished: [this.gln?.isPublished || false, null],
      organisationCode: [this.gln?.organisationCode || null, null],
      codeNumberSiret: [
        this.gln?.codeNumberSiret || null,
        Validators.compose([
          Validators.maxLength(14),
          Validators.minLength(14),
          Validators.pattern('^\\d+$'),
        ]),
      ],
      codeNumberIntern: [
        this.gln?.codeNumberIntern || null,
        Validators.compose([Validators.maxLength(14)]),
      ],
      codeNumber: [
        this.gln?.codeNumberSiret || this.gln?.codeNumberIntern || null,
      ],
    });

    if (this.gln?.glnType?.isDigitalLocation) {
      this.GLNForm?.get('digitalAddress')?.addValidators(Validators.required);
    }
    if (this.gln?.organisationCode == this.organisationCodes[0].value) {
      this.GLNForm?.get('codeNumberSiret')?.setValue(this.gln?.codeNumber)
    }
    if (this.gln?.organisationCode == this.organisationCodes[1].value) {
      this.GLNForm?.get('codeNumberIntern')?.setValue(this.gln?.codeNumber)
    }

    this.subs.push(
      // Change the requirement of the form if isDigitalLocation changes.
      this.GLNForm.get("glnType")?.get("isDigitalLocation")?.valueChanges.subscribe((value: boolean) => {
          this.islocation = value || this.GLNForm?.get("glnType")?.get("isFixedPhysicalLocation")?.value;
          this.checkRoleType();
          if (value === true) {
            this.GLNForm?.get("digitalAddress")?.addValidators(Validators.required);
          } else {
            this.GLNForm?.get("digitalAddress")?.removeValidators(Validators.required);
          }
          this.GLNForm?.get("digitalAddress")?.updateValueAndValidity();
          this.GLNForm?.get("digitalAddress")?.hasValidator;
        })
    );

    this.subs.push(
      // Change the requirement of the form if isDigitalLocation changes.
      this.GLNForm.get('glnType')?.get('isFixedPhysicalLocation')?.valueChanges.subscribe((value: boolean) => {
          this.islocation = value || this.GLNForm?.get('glnType')?.get('isDigitalLocation')?.value;
          this.checkRoleType();
      })
    );

    this.subs.push(
      this.GLNForm.get('glnType')?.get('isFunction')?.valueChanges.subscribe((value: boolean) => {
          this.isorganization = value;
          this.checkRoleType();
        })
    );
  }

  /**
   * Returns the label for the given role type.
   * @param {string} roleType - the role type's value to get the label for.
   * @returns {string} the label for the given role type.
   */
  getLabelForRoleType(roleType?: string) {
    if (!roleType) {
      return '';
    }
    return RoleTypesList.filter((role) => role.value === roleType)[0].label;
  }

  getLabelForOrganisationCode(organisationCode?: string) {
    if (!organisationCode) {
      return '';
    }
    return OrganisationCodesList.filter((code: { value: string; }) => code.value === organisationCode)[0].label;
  }

  checkRoleType() {
    if (this.islocation && !this.isorganization) {
      this.roleTypesListFilter = this.roleTypesList.filter((item) => item.id !== 'ISORGANIZATION').sort((a, b) => a.label.localeCompare(b.label));
    }else if (!this.islocation && !this.isorganization) {
      this.roleTypesListFilter = RoleTypesList.filter((item) => item.id !== 'ISLocation' && item.id !== 'ISORGANIZATION').sort((a, b) => a.label.localeCompare(b.label));
    } else if (!this.islocation && this.isorganization) {
      this.roleTypesListFilter = RoleTypesList.filter((item) => item.id !== 'ISLocation').sort((a, b) => a.label.localeCompare(b.label));
    } else {
      this.roleTypesListFilter = RoleTypesList.sort((a, b) => a.label.localeCompare(b.label));
    }

    if(this.gln?.roleType != null ) {
        const filtered = this.roleTypesListFilter.filter((glnType) =>
          this.gln?.roleType == glnType.value
        );
        if(filtered.length == 0) {
          if(this.gln?.roleType != "") {
            window.scrollTo(0,document.body.scrollHeight);
            this.initRoleType = true;
            this.oldRoleType = this.gln?.roleType;
            this.gln.roleType = '';
            this.sendNotificationWarn();
          }
        }
    }
  }

  /**
   * Copies the GLN to the clipboard.
   * @returns None
   */
  copyGLN() {
    if (this.gln) {
      navigator.clipboard.writeText(this.gln.gln);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    }
  }

  /**
   * Navigates to the main GLN if it exists.
   * @returns None
   */
  navigateToMainGLN() {
    if (this.gln && this.gln.mainGln) {
      this.edit = false;
      this.GLNForm = undefined;
      const url = (!this.fromSearch ? '/mes-gln' : '/recherche') + '/details/' + this.gln.mainGln;
      this.gln = undefined;
      this.router.navigateByUrl(url);
    }
  }

  /**
   * Cancels the editing of the GLN.
   * @returns None
   */
  cancelEdit() {
    this.initRoleType = false;
    this.GLNForm = undefined;
    this.edit = false;
    for (let sub of this.subs) {
      sub.unsubscribe();
    }
    if(this.oldRoleType != '' && this.gln != null) {
       this.gln.roleType = this.oldRoleType;
    }
    this.stopEdit.emit(this.gln);
  }

  showConfirmPopin(): void {
    const dialogOption: MatDialogConfig = new MatDialogConfig();
    dialogOption.autoFocus = false;
    dialogOption.panelClass = "goat-dialog";
    dialogOption.disableClose = false;
      dialogOption.maxWidth = "850px"
    this.dialogRef = this.dialog.open(this.dialogContent, dialogOption);
  }

  /**
   * Saves the changes made to the GLN and exit editing mode.
   * @returns None
   */
  async saveChanges() {
    if (this.GLNForm && this.GLNForm.valid) {

      const oldAddressValue =
        this.GLNForm.value?.address?.streetAddress +
        this.GLNForm.value?.address?.postalCode +
        this.GLNForm.value?.address?.addressLocality;

      const newAddressValue =
        this.gln!.address!.streetAddress! +
        this.gln!.address!.postalCode! +
        this.gln!.address!.addressLocality!;

      let nameChanged = this.GLNForm.controls.name.dirty;

      this.isNewAddress = oldAddressValue !== newAddressValue ? true : false;
      const codeNumber = this.GLNForm.get('organisationCode')?.value  === this.organisationCodes[0].value  ? this.GLNForm.get('codeNumberSiret')?.value : this.GLNForm.get('codeNumberIntern')?.value
      this.GLNForm.get('codeNumber')?.setValue(codeNumber);
      if (nameChanged || this.isNewAddress) {
        this.showConfirmPopin();
        return;
      }
      else {
        this.save(this.isNewAddress, this.GLNForm);
      }
    }
  }

  //Save modification.
  async save(isNewAddress: boolean, form: any) {

    const modifiedGLN: GLN = { ...this.gln, ...form.value };
    const fullAddress: string = `${modifiedGLN?.address?.streetAddress + ' ' + modifiedGLN?.address?.postalCode + ' ' + modifiedGLN?.address?.addressLocality}`;
    this.loading.startLoading('GLNSave');

    try {

      if (isNewAddress && !this.isAutoSet) {
        this.isAddressChange = true;
        await this.getGeoCodeAddress(fullAddress);
        modifiedGLN!.latitude = this.gln?.latitude;
        modifiedGLN!.longitude = this.gln?.longitude;
      }

      const filtered = this.roleTypesListFilter.filter((glnType) =>
        modifiedGLN.roleType == glnType.value
      );

      if(filtered.length == 0) {
        if(modifiedGLN.roleType != "") {
          modifiedGLN.roleType = undefined;
        }
      }

      // modifiedGLN.address!.countryCode = this?.countryCode;
      const backGLN: GLNInterface = await this.glnService.saveGLN(modifiedGLN);
      // Fresh data from database by id.
      const backGLNRefresh: GLNInterface = await this.glnService.getGlnById(backGLN.id)

      this._storage.forceGLNRefresh = true;
      const updatedGLN =  { ...this.gln, ...backGLNRefresh };
      this.gln = new GLN(updatedGLN);



    } catch {
      this.loading.stopLoading('GLNSave');
      return;
    }
    this.initRoleType = false;
    this.loading.stopLoading('GLNSave');
    this.GLNForm = undefined;
    this.edit = false;
    this.initiateGlnMap();
    this.stopEdit.emit(this.gln);
  }

  /**
   * Start the edit state of the component.
   * @returns None
   */
  startEdition() {
    this.startEdit.emit();
    this.edit = true;
    this.initiateForm();
    this.islocation = this.GLNForm?.get('glnType')?.get('isDigitalLocation')?.value || this.GLNForm?.get('glnType')?.get('isFixedPhysicalLocation')?.value;
    this.isorganization = this.GLNForm?.get('glnType')?.get('isFunction')?.value;
    this.checkRoleType();
  }

  /**
   * A validator that checks if at least one checkbox is selected.
   * @returns {ValidatorFn} A validator that checks if at least one checkbox is selected.
   */
  atLeastOne(): ValidatorFn {
    return (control: AbstractControl) => {
      const values = control.value;
      for (let key in values) {
        if (values[key] === true) {
          return null;
        }
      }
      return { nothingSelected: true };
    };
  }

  /**
   * Checks if the digital address field is required.
   * @returns {boolean} - True if the digital address field is required.
   */
  isDigitalAdressRequired() {
    return (this.GLNForm && this.GLNForm.get('digitalAddress')?.hasValidator(Validators.required));
  }

  isGeolocalisationSet() {
    var lat = this.gln?.latitude;
    var long=this.gln?.longitude;
    if(lat=="0" && long=="0")
      return false;

    return !!this.gln?.latitude && !!this.gln?.longitude;
  }

  async saveGlnGeolocalisationAsync(updatedGln: GLN) {
    this.loading.startLoading('GLNSave');
    try {
      const backGLN: GLNInterface = await this.glnService.saveGLN(updatedGln);
      this._storage.forceGLNRefresh = true;
      const updatedGLN = { ...this.gln, ...backGLN };
      this.gln = new GLN(updatedGLN);
    } catch {
      this.loading.stopLoading('GLNSave');
      return;
    }
    this.loading.stopLoading('GLNSave');
    this.edit = false;
    this.stopEdit.emit(this.gln);
  }

  async checkIfGeolocalisationIsSet(address: any) {
    if (!this.isGeolocalisationSet() && address !== null) {
      const fullAddress: string = `${address?.streetAddress + ' ' + address?.postalCode + ' ' + address?.addressLocality}`;
      await this.getGeoCodeAddress(fullAddress);
    }

    if(this.isGeolocalisationSet()) {
      this.initiateGlnMap();
    }
  }

  async getGeoCodeAddress(address: any) {
     const geoCoderRequest: google.maps.GeocoderRequest = { address: address };

     const isAddressNotSet = (this.gln!.latitude=="0" && this.gln!.longitude=="0") || (this.gln!.latitude==undefined && this.gln!.longitude==undefined);

     var geoCodeReponse = await firstValueFrom(
       this._geoCoder.geocode(geoCoderRequest)
     );

     switch (geoCodeReponse.status) {
       case google.maps.GeocoderStatus.OK: {
         const lat = geoCodeReponse.results[0]?.geometry.location.lat().toString();
         const lng = geoCodeReponse.results[0]?.geometry.location.lng().toString();

         this.gln!.latitude = lat;
         this.gln!.longitude = lng;

         if ((!this.isAddressChange && !this.gln?.isMain && this.gln?.companyId == this.idCompany)||(isAddressNotSet && !this.gln?.isMain)) {
           this.saveGlnGeolocalisationAsync(this.gln!);
         }
         break;
       }
       case google.maps.GeocoderStatus.ZERO_RESULTS: {
         this.gln!.latitude = undefined;
         this.gln!.longitude = undefined;
         break;
       }
     }
  }

  AddressChange(address: any) {
     this.isAutoSet = true;
     this.streetNumber = '';
     this.GLNForm?.get('address.streetAddress')?.setValue('');
     this.GLNForm?.get('address.countryCode')?.setValue('');
     this.GLNForm?.get('address.addressLocality')?.setValue('');
     this.GLNForm?.get('address.postalCode')?.setValue('');

     this.gln!.latitude = address.geometry.location.lat().toString();
     this.gln!.longitude = address.geometry.location.lng().toString();

     for (const addressComponent of address.address_components as google.maps.GeocoderAddressComponent[]) {
       const type = addressComponent.types[0];

       switch (type) {
         case 'street_number': {
           this.streetNumber = `${addressComponent.long_name + ' '}`;
           break;
         }
         case 'route': {
           this.GLNForm?.get('address.streetAddress')?.setValue(`${this.streetNumber += addressComponent.long_name}`)
           break;
         }
         case 'country': {
           this.GLNForm?.get('address.countryCode')?.setValue(`${addressComponent.short_name}`)
           if (this.gln && this.gln.address && this.gln.address.countryCode) {
             this.countryName = countryList.filter(
               (country) => this.gln && country['Code alpha-2'] === this.gln.address?.countryCode)[0]['wording-fr'];
           }
           break;
         }
         case 'locality': {
           this.GLNForm?.get('address.addressLocality')?.setValue(`${addressComponent.long_name}`)
           break;
         }
         case 'postal_code': {
           this.GLNForm?.get('address.postalCode')?.setValue(`${addressComponent.long_name}`)
           break;
         }
       }
     }
  }

  shouldShowCodeNumber(): boolean {
    const value : string = this.GLNForm?.get('organisationCode')?.value as string || '';
    return  value.length !== 0 ;
  }

  showError(controlName: string, error?: string): boolean {
    const control = this.GLNForm?.get(controlName);
    if (!control || !control.errors || !(control.dirty || control.touched)) {
      return false;
    }
    if (!error) {
      return !control.valid;
    }
    return control.hasError(error);
  }

  // If modification accepted. Save Edition.
  acceptModification() {
    this.dialogRef.close();
    this.save(this.isNewAddress, this.GLNForm);
  }
  // If modification refused. Cancel Edit.
  refuseModification() {
    this.dialogRef.close();
    this.cancelEdit()
  }

 //If Role changed show information messages.
 sendNotificationWarn() {
  this.notifications.addNotification('Veuillez vérifier le rôle de votre GLN.', 'info');
 }

 //format number , to .;
 formatGpsCord(latOrLong:string|undefined) {
    return latOrLong?.replace(',', '.');
 }
}
